import React from 'react';
import { Mui } from '@leap4/frontend';

const { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } = Mui;

interface DeleteRunLogsModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    selectedCount: number;
}

const DeleteRunLogsModal: React.FC<DeleteRunLogsModalProps> = ({
    open,
    onClose,
    onConfirm,
    selectedCount
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to delete {selectedCount} {selectedCount === 1 ? 'log' : 'logs'}?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteRunLogsModal; 